//import * as actions from '../../actions/actionTypes';

const initialState = [];

export default function genres(state = initialState, action) {
  switch (action.type) {
    case 'SET_HOMEAPP_GENRE':
      return action.payload;
    default:
      return state;
  }
}
